var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_320)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2963_320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.42857V7.46667H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 0V1.06667H22V0H9.42857ZM9.42857 2.13333V3.2H22V2.13333H9.42857ZM9.42857 4.26667V5.33333H22V4.26667H9.42857ZM9.42857 6.4V7.46667H22V6.4H9.42857ZM0 8.53333V9.6H22V8.53333H0ZM0 10.6667V11.7333H22V10.6667H0ZM0 12.8V13.8667H22V12.8H0ZM0 14.9333V16H22V14.9333H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04785 1.06665V2.13332H2.09547V1.06665H1.04785ZM3.14309 1.06665V2.13332H4.19071V1.06665H3.14309ZM5.23833 1.06665V2.13332H6.28595V1.06665H5.23833ZM7.33357 1.06665V2.13332H8.38119V1.06665H7.33357ZM6.28595 2.13332V3.19998H7.33357V2.13332H6.28595ZM4.19071 2.13332V3.19998H5.23833V2.13332H4.19071ZM2.09547 2.13332V3.19998H3.14309V2.13332H2.09547ZM1.04785 3.19998V4.26665H2.09547V3.19998H1.04785ZM3.14309 3.19998V4.26665H4.19071V3.19998H3.14309ZM5.23833 3.19998V4.26665H6.28595V3.19998H5.23833ZM7.33357 3.19998V4.26665H8.38119V3.19998H7.33357ZM1.04785 5.33332V6.39998H2.09547V5.33332H1.04785ZM3.14309 5.33332V6.39998H4.19071V5.33332H3.14309ZM5.23833 5.33332V6.39998H6.28595V5.33332H5.23833ZM7.33357 5.33332V6.39998H8.38119V5.33332H7.33357ZM6.28595 4.26665V5.33332H7.33357V4.26665H6.28595ZM4.19071 4.26665V5.33332H5.23833V4.26665H4.19071ZM2.09547 4.26665V5.33332H3.14309V4.26665H2.09547Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    stroke: "#CECECE",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2963_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.0699d829.svg";
export { ForwardRef as ReactComponent };